import { RouteRecordRaw } from 'vue-router';
import AuthWrapper from '@/views/auth/Index.vue';
import AccountWrapper from '@/views/account/Index.vue';
import Login from '@/views/auth/login/Index.vue';
import Profile from '@/views/account/profile/Index.vue';
import Security from '@/views/account/security/Index.vue';
import Notifications from '@/views/account/notifications/Index.vue';

export const routes: RouteRecordRaw[] = [
    {
        path: '/auth',
        component: AuthWrapper,
        children: [
            {
                path: 'login',
                name: 'Login',
                component: Login,
            },
        ],
    },
    {
        path: '/account',
        component: AccountWrapper,
        meta: { requiresAuth: true },
        redirect: '/account/profile',
        children: [
            {
                path: 'profile',
                name: 'Profile',
                component: Profile,
            },
            {
                path: 'security',
                name: 'Security',
                component: Security,
            },
            {
                path: 'notifications',
                name: 'Notifications',
                component: Notifications,
            },
        ],
    },
    {
        path: '/',
        redirect: '/account/profile',
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/account/profile',
    },
];
